<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-07 17:43:58
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 20:28:06
-->
<template>
  <div id="cockpit">
    <div class="cockpitLeft">
      <cockpit-left></cockpit-left>
    </div>
    <section class="header" @click="onBack()">
      <img src="@/assets/heads.png" alt="" />
    </section>
    <mapCenter />
    <div class="cockpitCenter">
      <cockpit-bottom></cockpit-bottom>
    </div>
    <div class="cockpitRight">
      <right-component></right-component>
    </div>
    <DialogComponent
      :isShowDialog="isShowDialog"
      :title="title"
      :enTitle="enTitle"
    ></DialogComponent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import rightComponent from './components/right/index.vue'
import CockpitLeft from './components/left/index'
import cockpitBottom from './components/bottom/index.vue'
import mapCenter from './components/mapCenter'
import DialogComponent from './components/dialog'
import { setRem } from '@utils'
export default {
  name: 'BigScreen',
  computed: {
    ...mapGetters(['dialogInfo'])
  },
  components: {
    mapCenter,
    CockpitLeft,
    rightComponent,
    cockpitBottom,
    DialogComponent
  },
  watch: {
    dialogInfo: {
      handler(value) {
        this.title = value.title
        this.enTitle = value.enTitle
        this.isShowDialog = value.show
      },
      immediate: true
    }
  },
  data() {
    return {
      isShowDialog: false,
      title: ''
    }
  },
  methods: {
    onBack() {
      this.$router.push({ path: 'dashboard' })
    }
  },
  mounted() {
    setRem()
    window.onresize = () => {
      setRem()
    }
  },
  beforeDestroy() {
    // 离开运行监测-恢复根元素font-size大小 清空yxjcCurrentMenu
    setRem(14)
    window.onresize = null
  }
}
</script>

<style lang="scss" scoped>
#cockpit {
  width: 100%;
  height: 100%;
  position: relative;
  .header {
    position: absolute;
    left: 0;
    top: -15px;
    cursor: pointer;
    width: 100%;
    z-index: 99;
    img {
      width: inherit;
    }
  }
}
.cockpitCenter {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 53%;
  height: 280px;
  z-index: 500;
  background: linear-gradient(
    to bottom,
    rgba(0, 34, 101, 0),
    rgba(0, 15, 45, 50%)
  );
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform: translate(-50%, 0);
}
.cockpitRight {
  position: absolute;
  right: 0;
  z-index: 500;
  box-sizing: border-box;
  width: 23%;
  height: 100%;
  padding: 66px 0 20px;
  background: linear-gradient(
    to right,
    rgba(0, 34, 101, 0),
    rgba(0, 15, 45, 100%)
  );
}
.cockpitLeft {
  position: absolute;
  right: left;
  bottom: 0;
  z-index: 79;
  box-sizing: border-box;
  width: 23%;
  height: 37%;
  padding: 66px 0 20px;
  // background: linear-gradient(
  //   to left,
  //   rgba(0, 34, 101, 0),
  //   rgba(0, 15, 45, 100%)
  // );
}
</style>
